module.exports = __webpack_public_path__ + "img/icon-register-success.5b247ab3.png";